import { STEP_OPTIONS } from "Pages/ViewRuns/OpenRuns/constants";

const CONTROL_FOR_RUN_STEP_VALUES = ["3", "5", "6"];

export const CONTROL_STEP_OPTIONS = STEP_OPTIONS.filter((option) =>
  CONTROL_FOR_RUN_STEP_VALUES.includes(option.value)
);
